/**
 * Copyright 2025 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

export enum DeviceType {
  Camera = 'camera',
  Microphone = 'microphone',
}
